// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--HoU9Q","logo":"logo--vQZ+o","footer":"footer--fd9Ci"};